import cn from 'classnames';
import Image from 'next/image';
import BaseModal from '@/components/modal/lib/BaseModal';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import './ProductZoomModal.style.scss';

type ProductZoomModalProps = {
  className?: string;
  onClose: () => void;
  imageSrc: string;
};

function ProductZoomModal(props: ProductZoomModalProps) {
  const { className = '', onClose, imageSrc } = props;

  return (
    <BaseModal
      className={cn('ProductZoomModal', className)}
      onClose={onClose}
    >
      <TransformWrapper
        disablePadding={true}
        maxScale={3}
      >
        {/* 
          Chrome's device emulator has navigator.maxTouchPoints as 1 and so we only want the class to change the height on real mobile devices. The height from this class calculates the available space with the browser navigation bar (safari/chrome) instead of ignoring it.

          https://stackoverflow.com/questions/28083715/how-to-detect-if-a-mobile-device-is-emulated-by-google-chrome#comment108747578_28084346

          react-device-detect really can't tell if it's a real device or if it's the emulator, anymore
        */}
        <TransformComponent
          contentClass={cn('', { isMobile: navigator.maxTouchPoints > 1 })}
        >
          <Image
            className='ProductZoomModal-img'
            src={imageSrc as string}
            alt=''
            layout='fill'
            objectFit='contain'
          />
        </TransformComponent>
      </TransformWrapper>
    </BaseModal>
  );
}

export default ProductZoomModal;
